<template>
  <div class="public-banner-content">
    <div
      class="public-banner-image"
      :style="{ backgroundImage: `url(${publicPageStoreBannerImageSrc})` }"
    ></div>
    <div class="public-overlay-image">
      <h1 class="public-banner-title">
        {{ publicPageStoreBannerImageTitle }}
      </h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PublicPageMixin from '@/mixins/public-page-mixin'
import { PublicPageStore } from '@/store/brand-plataform-page/public-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PublicBannerSection extends Mixins(PublicPageMixin) {
  publicPageStore: PageStoreContract = getModule(PublicPageStore, this.$store)

  get publicPageStoreBannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get publicPageStoreBannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getPublicPageStore(): Promise<void> {
    await this.publicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.publicPageStore.isLoading) {
      await this.getPublicPageStore()
    }
  }
}
</script>

<style lang="scss">
.public-banner-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  max-height: 28rem;
  width: 100%;
  justify-items: center;
  justify-content: center;
}

.public-banner-image {
  position: relative;
  width: 100%;
  height: 451px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.public-overlay-image {
  position: absolute;
  bottom: 9rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.public-banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  letter-spacing: -0.01em;
  text-align: left;
}
</style>
